export const SAVED_CHECKLIST_SCHEMA_VERSION = 1 as const;

export const TITLE_MIN_LENGTH = 1;
export const TITLE_MAX_LENGTH = 100;
export const DESCRIPTION_MAX_LENGTH = 500;
export const PIN_IDS_MAX_COUNT = 500;

export interface SavedChecklist {
    id: string;
    title: string;
    description: string;
    pinIds: string[];
    createdBy: string;
    createdAt: number;
    updatedAt: number;
    version: number;
}

export interface CreateSavedChecklistInput {
    title: string;
    description: string;
    pinIds: string[];
}

export interface UpdateSavedChecklistInput {
    title?: string;
    description?: string;
    pinIds?: string[];
}

export interface ListSavedChecklistsResponse {
    checklists: SavedChecklist[];
}

export interface SavedChecklistResponse {
    checklist: SavedChecklist;
}

export type SavedChecklistErrorCode =
    | 'invalid_title'
    | 'invalid_description'
    | 'invalid_pin_ids'
    | 'invalid_body'
    | 'not_found'
    | 'unauthorized'
    | 'limit_exceeded'
    | 'internal_error';

export interface SavedChecklistErrorResponse {
    error: {
        code: SavedChecklistErrorCode;
        message: string;
    };
}
